<template>
  <section
    class="d-flex flex-row rounded-4 py-2 px-4 shadow"
    :class="'bg-blue-300'"
  >
    <div class="d-flex flex-column text-left">
      <div class="h5 mb-2">
        {{ memberFullName }}
      </div>
      <div> {{ memberPosition }} </div>
    </div>
    <div
      class="d-flex ms-auto my-auto"
      :class="isAccountAdmin ? 'invisible' : 'd-flex' "
    >
      <v-loading-icon
        :action="deleteMember"
      />
    </div>
  </section>
</template>
<script>

import { ui } from '@/mixins';

import LoaderIcon from '@/components/common/helpers/LoaderIcon.vue';

export default {
  components: {
    'v-loading-icon': LoaderIcon,
  },
  mixins: [ui],
  props: {
    member: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  computed: {
    isAccountAdmin() {
      return this.member.role.id === 7;
    },
    memberFullName() {
      return `${this.member.user.firstName} ${this.member.user.lastName}`;
    },
    memberPosition() {
      return this.member.user.position.label;
    },
  },
  methods: {
    deleteMember() {
      const action = async () => {
        await this.$store.dispatch('client/removeMember', this.member.id);
        await this.$store.dispatch('client/getMembers');
      };
      this.ui_accountModal({ type: 'deleteMember', value: true, action });
      return Promise.resolve();
    },
  },
};
</script>
